import { Sites } from '@ps/platform-message-framework/common/Sites';
import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  ExclusionType,
  SelfExclusion,
  exclusionTypeTimeouts,
  exclusionTypeTimeoutsIT
} from '../definitions';

const useExclusionType = (daysRequested?: number, nationalExclusion?: boolean) => {
  const site = useSelector(select.cms.getSiteId);
  const isSiteDE = useSelector(select.cms.isSiteDE);
  const selExclusion = nationalExclusion ? SelfExclusion.Nationally : SelfExclusion.Brand;
  const { [ExclusionType.Break]: takeBreak } =
    exclusionTypeTimeouts(site, isSiteDE) || exclusionTypeTimeoutsIT[selExclusion];

  if (isUndefined(daysRequested)) {
    return;
  }

  if (daysRequested === 0 && [Sites.POR, Sites.DEN].includes(site))
    return ExclusionType.PermanentSelfExclusion;

  return takeBreak.includes(daysRequested) ? ExclusionType.Break : ExclusionType.SelfExclusion;
};

export default useExclusionType;
